"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Objects = require("../util/Objects");

var _Analytics = _interopRequireDefault(require("../util/Analytics"));

var _Severity = _interopRequireDefault(require("../constants/Severity"));

var _EventGroups = _interopRequireDefault(require("../constants/EventGroups"));

var _Cookies = require("../util/Cookies");

var DEFAULT_CTA_TEXT = 'View status page';

var Alarm =
/*#__PURE__*/
function () {
  function Alarm(alarmData, dom, storage, events, date) {
    (0, _classCallCheck2.default)(this, Alarm);
    (0, _Objects.objectAssign)(this, alarmData);
    this.dom = dom;
    this.storage = storage;
    this.events = events;
    this.date = date || Date;
    this.severity = _Severity.default.getByKey(alarmData.severity);
    var id = this.id || this.uuid;
    this.alarmId = "alarm." + id + ".revision." + this.revisionNumber;
    this.className = 'Alarm';
    this.storageKey = "firealarm.dismiss." + this.alarmId;
    this.analyticsKey = "firealarm.analytics." + this.alarmId;
    this.domElement = null;
    this.alarmElementId = "firealarm-" + (this.id || this.date.now());
    this.alarmDismissButtonId = this.alarmElementId + "-dismiss";
  }

  (0, _createClass2.default)(Alarm, [{
    key: "dismiss",
    value: function dismiss() {
      _Analytics.default.trackUsage('dismiss-alarm-clicked', this.id, this.revisionNumber);

      this.storage.setItem(this.storageKey, "true");

      if (this.domElement) {
        var parent = this.domElement.parentNode;
        parent.removeChild(this.domElement);

        if (!parent.hasChildNodes()) {
          parent.parentNode.removeChild(parent);
        }
      }

      this.events.runEvents(_EventGroups.default.ON_DISMISS_ALARM, this);
    }
  }, {
    key: "getDomElement",
    value: function getDomElement() {
      var _this = this;

      if (!this.domElement) {
        var ctaText = this.callToAction && this.callToAction.ctaText || DEFAULT_CTA_TEXT;
        this.domElement = this.dom.createElementFromHtml("<div\n          id=\"" + this.alarmElementId + "\"\n          class=\"fire-alarm_alarm fire-alarm_" + this.severity.key.toLowerCase() + "\"\n          role=\"alert\"\n          aria-live=\"assertive\"\n          aria-atomic=\"true\" >\n            <div class=\"fire-alarm_alarm-inner\">\n              <div class=\"fire-alarm_alarm-body\">\n                <h2>" + this.title + "</h2>\n                <p>" + this.message + "</p>\n              </div>\n            </div>\n        </div>");

        if (this.callToAction) {
          var callToActionLink = this.dom.createElementFromHtml("<a class=\"fire-alarm_alarm-status-page-link\" href=\"" + this.callToAction.url + "\" target=\"_blank\">" + ctaText + "</a>");
          this.domElement.appendChild(callToActionLink);
          callToActionLink.addEventListener('click', this.trackCtaClick.bind(this));
        }

        var dismissButton = this.dom.createElementFromHtml("<button id=" + this.alarmDismissButtonId + " type=\"button\" data-action=\"close\" class=\"fire-alarm_alarm-close-button\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" class=\"alarm-close-icon\">\n            <path transform=\"translate(-1 -1)\" d=\"M14.5,1.5l-13,13m0-13,13,13\"></path>\n          </svg>\n          <span class=\"fire-alarm_alarm-button-text\">Close</span>\n        </button>");
        this.domElement.appendChild(dismissButton); // wire up dismiss button
        // This should handle click and touch events

        if (dismissButton) {
          var onDismissButton = function onDismissButton(event) {
            event.preventDefault();

            _this.dismiss();
          };

          dismissButton.addEventListener('touchend', onDismissButton);
          dismissButton.addEventListener('click', onDismissButton);
        }
      }

      return this.domElement;
    }
  }, {
    key: "isDismissed",
    value: function isDismissed() {
      return this.storage.getItem(this.storageKey) === "true";
    }
  }, {
    key: "hasTrackedViewEventToday",
    value: function hasTrackedViewEventToday() {
      return (0, _Cookies.getCookie)(this.analyticsKey);
    }
  }, {
    key: "trackViewEventIfNotTrackedToday",
    value: function trackViewEventIfNotTrackedToday() {
      if (!this.hasTrackedViewEventToday()) {
        _Analytics.default.trackUsage('viewed-fire-alarm', this.id, this.revisionNumber);

        var midnight = new Date().setHours(23, 59, 59, 59).valueOf();
        var now = new Date().valueOf();
        (0, _Cookies.setCookie)(this.analyticsKey, true, midnight - now);
      }
    }
  }, {
    key: "trackCtaClick",
    value: function trackCtaClick() {
      _Analytics.default.trackUsage('clicked-cta', this.id, this.revisionNumber);
    }
  }]);
  return Alarm;
}();

var _default = Alarm;
exports.default = _default;
module.exports = exports.default;